var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 564.37,
    height: 458.32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 564.37 458.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".g{fill:url(#f);}.h{fill:url(#e);}.i,.j,.k{fill:none;stroke-linecap:round;stroke-linejoin:round;}.i,.l{stroke:#0e090c;}.j{stroke:#231f20;}.m{fill:#f9f8f4;}.n{fill:#fff;}.o{fill:#fff7d3;}.p{fill:#d5dbe0;}.q,.l{fill:#0e090c;}.r{fill:#8898a9;}.l{stroke-miterlimit:10;}.k{stroke:#ea5599;stroke-dasharray:0 0 5 5;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 163.7,
    y1: -1198.15,
    x2: 215.9,
    y2: -1104.87,
    gradientTransform: "translate(0 -1097.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fad4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeff6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 180.33,
    y1: -1156.86,
    x2: 231.13,
    y2: -1135.13,
    gradientTransform: "translate(0 -1097.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#da202c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea5599"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M394.77,177.97s-16.6-99.12-9.9-100.24c40.09-6.72,81,14.65,97.41,53.76,19.14,45.65-1.92,98.47-47.57,117.61l-39.94-71.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M492.28,260.19c10.76-6.98,13.42-23.61,24.07-32.44,19.46-16.12,48.23-3.66,48.02,22.55-.21,26.45-27.34,39.75-19.5,60.11,7.19,18.68,7.9,39.31-4.41,57.1,0,0-13.79-10.79-43.91-19.95l-4.28-87.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M444.28,198.64c16.4-18.47,41.84-16.99,52.56,7.19,10.71,24.18-14.23,46.1-.67,63.19,17.03,21.47,24.71,47.59,.38,78.54,0,0-21.96-6.53-52.27-3.42V198.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M420.95,110.68c-2.25-13.51-16.33-18.02-20.55-21.12-4.22-3.1-10.98-7.88-14.64-21.4-1.3-4.8-2.2-9.85-5.43-15.66,0,0-1.38-2.59-3.95-5.92,.35,1.53,.67,3.16,.94,4.92,1.47,9.72,1.26,19.64,.5,27.92l.4,.23c2.71,3.25,3.9,8.89,2.74,14.9-1.09,5.66-4,10.23-7.44,12.42v.02c-2.2,1.56-5.32,4.51-10.44,3.37-6.31-1.41-9.97-10.17-8.07-19.98,1.89-9.81,8.57-16.77,14.92-15.54l.51,.3c1.15-11.36,1.08-23.85-1.94-34.27-.38-1.18-.81-2.29-1.27-3.33-5.17-3.74-12.33-6.27-20.61-6.27-26.19,0-40.83,24.5-40.83,24.5,11.54-1.13,19.4,3.7,26.19,8.17,5.77,3.8,11.15,6.36,16.05,4.22,4.9-2.14,3.66-8.45,3.66-8.45,0,0,4.79,12.11-3.38,31.82-8.17,19.71-21.15,32.2-16.61,48.71,3.94,14.33,19.48,14.1,19.48,14.1l13.18-29.59,30.41,53.21c11.26-2.25,12.11-14.92,9.85-20.27-2.25-5.35-3.66-13.23,3.94-18.86,7.6-5.63,14.64-14.64,12.39-28.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M254.55,413.19s.04-83.59,.04-105.27,13.19-31.5,24.53-31.5,21.82,6.26,21.82,6.26c0,0,52.78,26.65,68,33.58,15.22,6.93,33.88,7.14,33.88,7.14l-113.05-.11,34.01,61.79s-35.18,19.49-69.23,28.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M254.55,379.03h-56.04l61.8-138.57s18.34,15.82,44.61,15.82,36.23-8.1,46.33-13.9c0,0,35.62,26.07,83.46,6.72,0,0,9.57,16.2,9.57,32.99s-11.36,41.29-41.46,41.29c-15.87,0-29.04-3.9-51.9-15.48-22.86-11.58-49.97-25.24-49.97-25.24,0,0-10.16-6.26-21.82-6.26s-24.57,10.12-24.57,29.67v72.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M173.99,341.38c-17.33-6.89-25.85-8.59-35.16-43.1-8.91-33.03-32.58-45.13-56.1-38.09-24.87,7.45-30.48,35.02-20.75,64.58,6.05,18.38,2.83,31.29-2.45,39.89,0,0,28.37,52.45,106.27,56.57l19.01-9.64,12.28-27.48s6.81-30.83-23.1-42.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M276.95,175.94s-8.1,9.12-15.97,26.94c-8.99,20.36-5.98,33.72-.67,37.58s19.8-3.96,30.29-26.89c6.44-14.07,6.66-20.12,6.66-20.12l-20.31-17.52Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 74.73,
    cy: 188.83,
    r: 38.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 397.67,
    cy: 341.85,
    r: 38.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M322.66,152.3c-13.14-10.23-4.17-24.77-4.17-24.77,0,0,4.47,3.91,12.28,3.64l-.32,3.62-7.8,17.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M394.77,177.97c11.26-2.25,12.11-14.92,9.85-20.27s-3.66-13.23,3.94-18.86c7.6-5.63,14.64-14.64,12.39-28.16s-16.33-18.02-20.55-21.12-10.98-7.88-14.64-21.4c-1.3-4.8-2.2-9.85-5.43-15.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M367.23,37.55c-5.26-3.62-12.34-6.27-20.61-6.27-26.19,0-40.83,24.5-40.83,24.5,11.54-1.13,19.4,3.7,26.19,8.17,5.77,3.8,11.15,6.36,16.05,4.22,4.9-2.14,3.66-8.45,3.66-8.45,0,0,4.79,12.11-3.38,31.82-8.17,19.71-21.15,32.2-16.61,48.71,3.94,14.33,19.48,14.1,19.48,14.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M311.99,59.72s-7.35,15.35-6.19,37.92c1.13,21.94,11.71,32.57,22.23,33.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "i",
    points: "322.08 78.63 317.35 94.93 320.81 95.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M329.05,80.83s4.15-5.45,7.94,.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M310,78.73s3.57-5.45,6.83,.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M366.53,119.89l-32.77,73.57-79.21-44.76s1.63-6.92-3.11-10.49-12.1-1.9-12.1-1.9c0,0-4.51-6.41-10.22-8.32-5.7-1.9-9.27,2.8-9.27,2.8l17.34,11.69"
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 330.77,
    y1: 134.08,
    x2: 310.25,
    y2: 180.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M207.03,359.94l-23.01,51.64c-26.5,12.28-52.08,28.54-55.86,46.24l76.54-31.72-8.82-15.44,16.34-27.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M382.11,163.84c6.43,31.59-7.22,65.24-36.55,82.17-27.74,16.02-61.31,12.79-85.25-5.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M291.35,211.94c8.66-19.47,9.24-38.13,1.29-41.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 434.55,
    y1: 248.85,
    x2: 364.36,
    y2: 124.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M351.25,242.38c13.91,8.83,30.41,13.94,48.11,13.94,12.55,0,24.78-1.98,35.35-7.22,3.16-1.56,6.3-3.28,9.39-5.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M423.53,122.16c1.71-.34,3.44-.62,5.19-.86,49.19-6.75,94.53,27.66,101.28,76.84,.96,7.02,1.09,13.97,.45,20.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M195.86,410.65c-7.47,12.14-21.01,18.68-32.69,22.42l-4.81-7.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "i",
    points: "204.69 426.1 207.03 430.43 184.92 437.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 346.36,
    y1: 426.1,
    x2: 289.77,
    y2: 323.29
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "i",
    points: "247.31 260.19 199 260.19 199 198.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M262.93,198.64h-104.9s-12.8,13.56-21.12,21.88c-8.32,8.32-14.08,15.36-31.05,14.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M157.39,208.68v29.77s12.16-1.92,7.04-16.96c0,0,8.96-5.78,2.56-15.85l26.3,3.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M234.93,140.95h-50.23s13.54,15.79,31.36,15.79,33.42-4.48,33.42-4.48l47.78,41.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 189.78,
    y1: 145.82,
    x2: 214.82,
    y2: 147.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 194.48,
    y1: 149.38,
    x2: 216.63,
    y2: 150.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 199,
    y1: 152.11,
    x2: 218.33,
    y2: 154.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M79.61,238.44h100.61c0,4.34-3.52,7.86-7.86,7.86H87.47c-4.34,0-7.86-3.52-7.86-7.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M54.6,140.74l25.01,97.45h0c-4.2,1.08-8.49-1.45-9.56-5.66l-21.1-82.23c-1.08-4.2,1.45-8.49,5.66-9.56h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 182.15,
    y1: 246.3,
    x2: 0.5,
    y2: 246.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M164.03,250.68c-2.29,5.67-3.93,11.66-3.93,18.33,0,22.15,16.16,26.83,24.82,26.83,16.03,0,33.29-14.16,51.53-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M178.18,211.63c0,9.81-4.09,18.26-8.39,26.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M67.36,184.85c17.94-17.63,38.86-25.74,57.92-25.74,32.36,0,46.91,20.7,51.35,39.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M34.27,246.3c3.86-19.09,12.9-37.06,22.72-50.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M59,364.65c-23.12-33.6-27.47-72.81-27.47-90.23,0-8.15,.64-15.9,1.84-23.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M165.13,421.22c-49.67-3.84-81.15-24.5-100.97-49.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M251.97,413.48c-14.29,3.84-28.58,6.33-46.21,7.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M490.49,346.32c-8.19-1.79-17.06-2.93-26.37-2.93-62.57,0-97.13,19.51-137.42,39.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M43.98,379.03s31.25-13.97,17.99-54.27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 92.11,
    y1: 288.23,
    x2: 132.58,
    y2: 415.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 124.6,
    y1: 390.63,
    x2: 162.79,
    y2: 366.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 120.92,
    y1: 379.03,
    x2: 79.61,
    y2: 371.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 105.25,
    y1: 329.63,
    x2: 120.92,
    y2: 304.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 101.3,
    y1: 317.2,
    x2: 79.61,
    y2: 312.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 444.28,
    y1: 181.08,
    x2: 444.28,
    y2: 390.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 444.28,
    y1: 323.39,
    x2: 470.9,
    y2: 211.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 449.06,
    y1: 260.19,
    x2: 457.3,
    y2: 268.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 447.97,
    y1: 307.91,
    x2: 490.49,
    y2: 299.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 510.37,
    y1: 295.85,
    x2: 536.42,
    y2: 246.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 518.53,
    y1: 282.1,
    x2: 536.42,
    y2: 276.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 528.32,
    y1: 261.71,
    x2: 523.4,
    y2: 246.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 507.46,
    y1: 329.63,
    x2: 528.32,
    y2: 327.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M299.88,94.19s-15.07,8.76-1.64,26.53"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 300.94,
    cy: 123.86,
    r: 3.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M305.67,95.26c-4.68-.69-8.97-6.06-6.63-17.92s8.55-12.68,8.55-12.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M369.93,74.85c-6.35-1.22-13.03,5.73-14.92,15.54-1.89,9.81,1.76,18.57,8.07,19.98,5.12,1.14,8.24-1.81,10.44-3.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M367.64,78.63c-3.19,1.84-5.83,6.13-6.97,12.03-1.67,8.65,1.52,16.54,7.12,17.62,5.6,1.08,11.49-5.06,13.16-13.71,1.16-6.01-.03-11.66-2.74-14.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M369.2,30.8c3.17,3.68,6.46,9.97,8.12,20.72,2.51,16.62,.13,33.88-1.57,42.41-.48,2.42-2.98,3.86-5.32,3.08h0c-1.99-.67-3.15-2.72-2.7-4.77,3.08-14.18,5.43-35.24,.77-51.34-4.49-14.06-15.9-18.66-23.93-12.51"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 105.86,
    cy: 156.01,
    r: 12.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M254.55,371.63v-61.27c0-29.96,18.64-41.69,45.32-28.22s52.3,26.92,68.37,33.87c13.31,5.76,39.69,12.8,58.03,1.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M499.59,219.06c-.04,18.88-14.44,35.95-3.42,49.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M316.82,104.39s5.83-.6,11.2-1.39c0,0-3.55,13.49-7.91,6.65"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "q",
    cx: 331.97,
    cy: 80.47,
    r: 1.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "q",
    cx: 312.79,
    cy: 78.04,
    r: 1.51
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M189.78,107.82c29.77,0,53.91-24.14,53.91-53.91S219.56,0,189.78,0s-53.91,24.14-53.91,53.91,24.14,53.91,53.91,53.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M161.46,84.98h13.96l4.23-20.99h9.91l8.83,20.99h15.04l-10-23.07c8.92-3.44,14.68-12.3,14.68-21.26,0-10.86-8.11-18.73-19.73-18.73h-24.14l-12.79,63.05Zm20.63-33.11l3.51-17.28h10.45c4.77,0,8.02,3.26,8.02,7.69,0,4.79-4.32,9.59-10.27,9.59h-11.71Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.60e5a0b1c48aba686e08fc07b5549182.svg";
export { ForwardRef as ReactComponent };